import { Modal } from "../ui/modal/Modal"
import { ModalOk } from "../ui/modal/ModalOk"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"
import { useEffect, useMemo, useState } from "react"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"

import { useQuery } from "../../hooks/useQuery"
import useFetch from "../../hooks/useFetch"
import { useTranslation, Trans } from "react-i18next"

export const ModalEditarStory = ({ show, entry, setEntries }) => {
  const { url, opt } = useMemo(
    () => api.stories.read({ id: entry.id }),
    [entry]
  )
  const [data, isPending, err] = useFetch({ url, opt })
  const [newEntry, setNewEntry] = useState({
    id: -1,
    title: "",
    text: "",
    public: false,
  })

  useEffect(() => {
    if (!isPending && !err)
      setNewEntry({
        id: data.id,
        title: data.title,
        text: data.text,
        public: data.public,
      })
  }, [data, isPending, err])

  const updateEntry = useQuery(),
    showRes = useState(false)

  const runQuery = async () => {
    showRes[1](true)

    // recolecto toda la data necesaria para el fetch
    const tkn = getCookie("jwt"),
      { url, opt } = api.stories.update({
        token: tkn,
        story_id: newEntry.id,
        story: newEntry,
      })

    // ejecuto
    updateEntry.url.current = url
    updateEntry.opt.current = opt

    updateEntry.run({
      onOk: () => {
        setEntries((current) => ({
          total: current.total,
          entries: current.entries.map((c) => {
            if (c.id !== entry.id) return c
            return { ...newEntry }
          }),
        }))
      },
    })
  }

  const { t } = useTranslation()

  const Body = () => {
    if (isPending) return <span>{t(`ui.btns.loading`)}...</span>

    if (!isPending && err) return <span>ERROR: {JSON.stringify(err)}</span>

    return (
      <>
        <div className="p-3 pt-0" style={{ background: "hsl(0deg 0% 90%)" }}>
          <div className="form-group">
            <label className="form-label mt-4">{t(`admin.games.title`)}</label>
            <input
              onChange={(e) =>
                setNewEntry((current) => ({
                  ...current,
                  title: e.target.value,
                }))
              }
              value={newEntry.title}
              className="form-control"
              placeholder={t(`admin.games.title`)}
            />
          </div>

          <div className="form-group mt-4 d-flex align-items-center">
            <label className="form-label mb-0">
              {t(`modals.modal_edit_story.public`)}
            </label>
            <input
              type="checkbox"
              className="ms-2 me-3"
              checked={newEntry.public}
              onChange={(e) =>
                setNewEntry((current) => ({
                  ...current,
                  public: e.target.checked,
                }))
              }
            />
          </div>

          <div className="form-group">
            <label className="form-label mt-4">{t(`admin.games.text`)}</label>
            <textarea
              onChange={(e) =>
                setNewEntry((current) => ({ ...current, text: e.target.value }))
              }
              style={{ minHeight: "40vh" }}
              className="form-control"
              rows="3"
              defaultValue={newEntry.text}
              placeholder={t(`admin.games.insert_text_here`)}></textarea>
          </div>
        </div>
      </>
    )
  }

  const Footer = () => {
    const handleCancelar = () => show[1](false)
    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleCancelar()}>
          Cancelar
        </button>

        <button
          type="button"
          className="btn btn-primary"
          disabled={updateEntry.isPending}
          onClick={() => runQuery()}>
          {updateEntry.isPending
            ? t(`ui.btns.submiting`) + "..."
            : t(`ui.btns.save`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="editar-story"
        show={show}
        header={<center>{t(`modals.modal_edit_story.header`)}</center>}
        body={Body()}
        footer={Footer()}
      />

      {/* modales para los resultados */}

      {updateEntry.res && !updateEntry.err && (
        <ModalOk
          show={[showRes[0], show[1]]}
          body={msg(
            <Trans
              i18nKey="modals.modal_edit_story.sucess_msg"
              values={{ story: newEntry.title }}
              components={{ i: <i /> }}
            />
          )}
        />
      )}

      {updateEntry.res && updateEntry.err && (
        <ModalError show={showRes} res={updateEntry.res} />
      )}
    </>
  )
}
